import { createFileRoute } from '@tanstack/react-router'

import { AchDailyScreen } from './-components/ach-daily-screen.tsx'

export const Route = createFileRoute('/ach/daily')({
  component: AchDailyScreen
})
